<script setup lang="ts">
    import { ref, watch } from 'vue';
    import Modal, { ModalSize } from '../Modal.vue';
    import { __ } from '@/js/stores/expressions';
    import dayjs from 'dayjs';
    import LoadingDots from '../LoadingDots.vue';
    import { EyeIcon, HistoryIcon } from '@lucide/vue';
    import { IVersionHistory } from '@/js/services/api/coachingForm/types';
    import { RouterLink } from 'vue-router';
    import UserAvatar from '../UserAvatar.vue';

    const model = defineModel<string | null | undefined>();
    const versionHistory = ref<IVersionHistory | null>(null);
    const loading = ref<boolean>(true);

    watch(
        () => model.value,
        async () => {
            if (model.value) {
                versionHistory.value = null;
                loading.value = false;
            } else {
                versionHistory.value = null;
                loading.value = true;
            }
        },
        { immediate: true }
    );
</script>

<template>
    <Modal :show="model !== null" :size="ModalSize.Medium" @close="model = null">
        <h2 class="flex justify-center heading-md">
            {{ __('version-history') }}
            <HistoryIcon class="inline-block ml-1.5 size-5" />
        </h2>

        <LoadingDots v-if="loading" class="mt-6" />

        <template v-else>
            <h3 class="heading-base text-center mt-1.5">
                {{ versionHistory?.title }}
            </h3>

            <div class="-mx-8 -mb-8 mt-8">
                <table class="Table">
                    <thead>
                        <tr>
                            <th>{{ __('user') }}</th>
                            <th>{{ __('date') }}</th>
                            <th class="text-right">
                                {{ __('snapshot') }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="version in versionHistory?.versions" :key="version.id" class="">
                            <td>
                                <div class="flex items-center">
                                    <UserAvatar :label="version.user" size="sm" class="mr-2.5" />
                                    {{ version.user }}
                                </div>
                            </td>
                            <td>{{ dayjs(version.updatedAt).format('YYYY-MM-DD') }}</td>
                            <td class="text-right">
                                <RouterLink
                                    :to="`/manage-forms/versions/${version.id}`"
                                    class="inline-block w-8 h-8 -my-1.5 -mb-2.5 p-1 rounded-md custom-focus"
                                >
                                    <EyeIcon class="size-5" />
                                </RouterLink>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </template>
    </Modal>
</template>
